import axios from "./../../config/axios";

function findByID(id) {
    return axios().get(`/purchase/payments/${id}`);
}

function create(data) {
    return axios().post("/purchase/payments", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    });
}

function update(data) {
    return axios().put(`/purchase/payments/${data.id}`, data);
}
function remove(data) {
    return axios().delete(`/purchase/payments/${data.id}`);
}

function index(params) {

    params = {...params, limit: params.itemsPerPage, offset: (params.page - 1) * params.itemsPerPage};

    return axios().get("/purchase/payments", {
        params
    })
}

function bankAccounts() {
    return new Promise(resolve => {
        resolve({
            data: [
                {
                    id: 4,
                    code: "130001313",
                    name: "130001313 - Faisal Islamic Bank (USD)",
                    currency: {
                        id: 2,
                        name: "United States Dollar",
                        abbreviation: "USD"
                    }
                },
                {
                    id: 5,
                    code: "130001314",
                    name: "130001314 - Bank of Khartoum",
                    currency: {
                        id: 1,
                        name: "Sudanse Pounds",
                        abbreviation: "SDG"
                    }
                },
                {
                    id: 6,
                    code: "130001315",
                    name: "130001315 - Jazeera Jordanian Bank",
                    currency: {
                        id: 1,
                        name: "Sudanse Pounds",
                        abbreviation: "SDG"
                    }
                },
            ]
        })
    });
}

function post(data) {
    return axios().put(`/purchase/payments/${data.id}/post`)
}

function print(data) {
    return axios().get(`/purchase/payments/${data.id}`, {
        headers: {
            "Accept": "text/html"
        }
    });
}
function states() {
    // return new Promise( resolve => {
    //     resolve({
    //         data : [ 
    //         { text: "hi", value: 1},
    //         { text: "bye", value: 2}, 
    //         { text: "good", value: 3}
    //         ]
    //     })
    // })
    return axios().get("/purchase/payment-states")
}

export default {
    findByID,
    create,
    update,
    remove,
    index,
    bankAccounts,
    post,
    print,
    states
}